import { WizardLayoutFormWithCommonSection } from '../../components/WizardLayoutForm';

import * as styles from './HighcareCallbackRequested.module.css';
import HighCarePhone from './assets/Highcare_phonenumber.svg';

export type HighcareCallbackRequestedProps = {
  content?: React.ReactNode;
  translations: {
    back: string;
  };
  eventHandlers: {
    onBack: () => void;
  };
};

export const HighcareCallbackRequested = ({
  content,
  translations,
  eventHandlers,
}: HighcareCallbackRequestedProps): JSX.Element => {
  return (
    <WizardLayoutFormWithCommonSection
      isForwardHidden={true}
      backCopy={translations.back}
      onBack={eventHandlers.onBack}
    >
      <HighCarePhone className={styles.image} data-testid='callback-requested' />
      {content}
    </WizardLayoutFormWithCommonSection>
  );
};
